import type { Article } from "./types";
import { createAnEvent } from "./create-an-event";
import { rsvpAndCutoffDate } from "./rsvp-and-cutoff-date";
import { giftRegistryAndOnlineContributions } from "./gift-registry-and-online-contributions";
import { passwordProtectedEventPage } from "./password-protected-event-page";
import { onePlanPerEvent } from "./one-plan-per-event";
import { whatsappWeddingInvitation } from "./whatsapp-wedding-invitation";
import { qrCodeWeddingInvitation } from "./qr-code-wedding-invitation";
import { physicalAndDigitalInvitations } from "./physical-and-digital-invitations";
import { weddingPlanningChecklist } from "./wedding-planning-checklist";

export type { Article, ArticleBlock, ContentLocale } from "./types";

/** Every article, published or not. Pages must go through the getters below. */
export const ALL_ARTICLES: readonly Article[] = [
  createAnEvent,
  rsvpAndCutoffDate,
  giftRegistryAndOnlineContributions,
  passwordProtectedEventPage,
  onePlanPerEvent,
  whatsappWeddingInvitation,
  qrCodeWeddingInvitation,
  physicalAndDigitalInvitations,
  weddingPlanningChecklist,
];

/** Published articles, newest first (ties keep declaration order). */
export function getPublishedArticles(articles: readonly Article[] = ALL_ARTICLES): Article[] {
  return articles
    .filter((article) => article.published)
    .map((article, index) => ({ article, index }))
    .sort((a, b) => b.article.publishedAt.localeCompare(a.article.publishedAt) || a.index - b.index)
    .map(({ article }) => article);
}

/** A published article by slug; unknown and unpublished slugs both return undefined. */
export function getPublishedArticle(slug: string, articles: readonly Article[] = ALL_ARTICLES): Article | undefined {
  return articles.find((article) => article.published && article.slug === slug);
}
